import { Component, OnInit } from '@angular/core';
import { FormBuilder } from '@angular/forms';
import { Router, ActivatedRoute } from '@angular/router';
import { ApiConfiguration } from 'src/app/services/http/api-configuration';
import { ApiService } from 'src/app/services/http/api.service';
import { ToastClientService } from 'src/app/services/toast/toast-client.service';
import { ChannelProvider } from '../../shared/providers/channel.provider';
import { GeographyProvider } from '../../shared/providers/geography.provider';
import { RegionProvider } from '../../shared/providers/region.provider';

@Component({
  selector: 'app-users-profiles',
  templateUrl: './users-profiles.component.html',
  styleUrls: ['./users-profiles.component.scss']
})
export class UsersProfilesComponent implements OnInit {

  constructor( private apiService: ApiService,
    private apiConfig: ApiConfiguration,
    private fb: FormBuilder,
    private router: Router,
    private toast: ToastClientService,
    private route: ActivatedRoute,
    public regionProviders: RegionProvider,
    public channelProviders: ChannelProvider,
    public geoProviders: GeographyProvider,) { }

  ngOnInit() {
  }

}
